import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  applyStoredConsentOnLoad,
  getConsent,
  hasDecision,
  onOpenPreferences,
  setConsent,
} from '../lib/consent';
import './ConsentBanner.css';

export default function ConsentBanner() {
  const [open, setOpen] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    applyStoredConsentOnLoad();
    if (!hasDecision()) {
      setOpen(true);
    }
    return onOpenPreferences(() => {
      const stored = getConsent();
      setAnalytics(stored ? !!stored.analytics : false);
      setMarketing(stored ? !!stored.marketing : false);
      setShowDetails(true);
      setOpen(true);
    });
  }, []);

  if (!open) return null;

  const save = (state) => {
    setConsent(state);
    setOpen(false);
    setShowDetails(false);
  };

  return (
    <div
      className="consent-banner"
      role="dialog"
      aria-modal="false"
      aria-labelledby="consent-banner-title"
    >
      <div className="consent-banner__inner">
        {!showDetails ? (
          <>
            <div className="consent-banner__copy">
              <h2 id="consent-banner-title" className="consent-banner__title">
                We use cookies
              </h2>
              <p className="consent-banner__text">
                We use cookies for site analytics and to measure ad performance. Choose what
                you're comfortable with. You can change this anytime via the Cookie
                preferences link in the footer. See our{' '}
                <Link to="/privacy-policy" className="consent-banner__link">
                  Privacy Policy
                </Link>
                .
              </p>
            </div>
            <div className="consent-banner__actions">
              <button
                type="button"
                className="consent-banner__btn consent-banner__btn--ghost"
                onClick={() => save({ analytics: false, marketing: false })}
              >
                Reject all
              </button>
              <button
                type="button"
                className="consent-banner__btn consent-banner__btn--ghost"
                onClick={() => setShowDetails(true)}
              >
                Customize
              </button>
              <button
                type="button"
                className="consent-banner__btn consent-banner__btn--primary"
                onClick={() => save({ analytics: true, marketing: true })}
              >
                Accept all
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="consent-banner__copy">
              <h2 id="consent-banner-title" className="consent-banner__title">
                Cookie preferences
              </h2>

              <div className="consent-banner__row">
                <div>
                  <div className="consent-banner__rowTitle">Necessary</div>
                  <div className="consent-banner__rowText">
                    Required for the site to function. Always on.
                  </div>
                </div>
                <span className="consent-banner__locked">Always on</span>
              </div>

              <div className="consent-banner__row">
                <label className="consent-banner__rowLabel">
                  <div>
                    <div className="consent-banner__rowTitle">Analytics</div>
                    <div className="consent-banner__rowText">
                      Google Analytics and Microsoft Clarity. Helps us understand which pages
                      and features get used.
                    </div>
                  </div>
                  <input
                    type="checkbox"
                    checked={analytics}
                    onChange={(e) => setAnalytics(e.target.checked)}
                    aria-label="Allow analytics cookies"
                  />
                </label>
              </div>

              <div className="consent-banner__row">
                <label className="consent-banner__rowLabel">
                  <div>
                    <div className="consent-banner__rowTitle">Marketing</div>
                    <div className="consent-banner__rowText">
                      Google Ads conversion tracking and remarketing.
                    </div>
                  </div>
                  <input
                    type="checkbox"
                    checked={marketing}
                    onChange={(e) => setMarketing(e.target.checked)}
                    aria-label="Allow marketing cookies"
                  />
                </label>
              </div>
            </div>

            <div className="consent-banner__actions">
              <button
                type="button"
                className="consent-banner__btn consent-banner__btn--ghost"
                onClick={() => save({ analytics: false, marketing: false })}
              >
                Reject all
              </button>
              <button
                type="button"
                className="consent-banner__btn consent-banner__btn--primary"
                onClick={() => save({ analytics, marketing })}
              >
                Save preferences
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
